export default __webpack_public_path__ + "static/media/exclusive.52662065.jpg";